"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _utils = require("../../utils");
var _composeStencilComponent = require("../../utils/composeStencilComponent");
var _constants = require("./constants");
var _helperComponents = require("./helperComponents");
var _core = require("@emotion/core");
var _excluded = ["children", "lg", "md", "sm"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var GridItem = function GridItem(_ref) {
  var children = _ref.children,
    lg = _ref.lg,
    md = _ref.md,
    sm = _ref.sm,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return (0, _core.jsx)(_helperComponents.GridBase, (0, _extends2.default)({
    lg: lg,
    md: md,
    sm: sm,
    className: _constants.GRID_ITEM_CLASS_NAME
  }, (0, _utils.pickDataProps)(props)), children);
};
var _default = (0, _composeStencilComponent.composeStencilComponent)({
  baseComponent: GridItem,
  displayName: 'GridItem',
  description: 'Component which determines the number of columns which will be used by child components per viewport breakpoint.',
  propTypes: {
    lg: _stencilReactDesc.PropTypes.oneOf((0, _utils.getRangeArray)(1, _constants.GRID_COLUMNS.lg)).description('Indicates how many columns are occupied by the component on lg breakpoint'),
    md: _stencilReactDesc.PropTypes.oneOf((0, _utils.getRangeArray)(1, _constants.GRID_COLUMNS.md)).description('Indicates how many columns are occupied by the component on md breakpoint'),
    sm: _stencilReactDesc.PropTypes.oneOf((0, _utils.getRangeArray)(1, _constants.GRID_COLUMNS.sm)).description('Indicates how many columns are occupied by the component on sm breakpoint')
  },
  defaultProps: _objectSpread({}, _constants.gridDefaultProps)
});
exports.default = _default;